// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"_6cfdead1","count":"_8eef4b86","term":"_81bbcf0b","returnToAll":"_d52e5135"};